var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_981_1917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.375058H1.5C1.20504 0.372056 0.920934 0.486188 0.710024 0.692411C0.499114 0.898635 0.378626 1.1801 0.375 1.47506V14.5276C0.379282 14.8221 0.500058 15.1029 0.710896 15.3086C0.921735 15.5143 1.20547 15.6281 1.5 15.6251H14.5C14.795 15.6274 15.0789 15.5129 15.2897 15.3065C15.5005 15.1002 15.621 14.8188 15.625 14.5238V1.47131C15.6197 1.17722 15.4986 0.897091 15.288 0.691815C15.0773 0.486538 14.7941 0.372705 14.5 0.375058Z",
    fill: "#0076B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63264 6.0918H4.89639V13.3755H2.63264V6.0918ZM3.76514 2.4668C4.02478 2.4668 4.27859 2.54381 4.49445 2.68808C4.71032 2.83235 4.87855 3.03741 4.97785 3.27731C5.07715 3.51721 5.10307 3.78118 5.05233 4.03581C5.00158 4.29045 4.87645 4.52431 4.69277 4.70782C4.50909 4.89132 4.27511 5.01623 4.02043 5.06673C3.76574 5.11723 3.5018 5.09106 3.262 4.99153C3.02219 4.892 2.81729 4.72358 2.67323 4.50757C2.52916 4.29157 2.45239 4.03769 2.45264 3.77805C2.45297 3.43017 2.5914 3.09665 2.8375 2.85078C3.08361 2.60491 3.41726 2.4668 3.76514 2.4668ZM6.31639 6.0918H8.48639V7.0918H8.51639C8.81889 6.5193 9.55639 5.91555 10.6576 5.91555C12.9501 5.91055 13.3751 7.4193 13.3751 9.37555V13.3755H11.1114V9.8318C11.1114 8.98805 11.0964 7.9018 9.93514 7.9018C8.77389 7.9018 8.57639 8.8218 8.57639 9.7768V13.3755H6.31639V6.0918Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_981_1917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.cef9acdcbbffbd525cd16249409fe923.svg";
export { ForwardRef as ReactComponent };